import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import NotLoggedIn from "../views/NotLoggedIn.vue";
import LoggedIn from "../views/LoggedIn.vue";
import NotFound from "../views/NotFound.vue";
import Feedback from "../views/Feedback.vue";
import LoginAs from "../views/LoginAs.vue";
import Redirect from "../views/Redirect.vue"
import BupaSso from "../views/BupaSso.vue";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TCs from "../pages/TCs";
import Video from '@/pages/Video.vue'

Vue.use(VueRouter);

//flatten the nav json into an object with the route item names as keys and the item object as the value
// let navItemsFlat = [];
// store.state.nav.forEach((navItem) => {
//   navItemsFlat.push(navItem);
//   if (navItem.hasOwnProperty('sub_items')) {
//     navItem.sub_items.forEach((subItem) => {
//       navItemsFlat.push(subItem);
//     });
//   }
// });
// let navItems = {}
// navItemsFlat.forEach((navItem) => {
//   navItems[navItem.item_slug] = navItem;
// });
const beforeEnterHandler = function (to, from, next) {
  if (store.getters.user.authenticated) {
    if(store.getters.isSaml){
      if (!store.getters.user.user.tc_accepted) {
        next('/terms-and-conditions').catch(() => { });
      };
      if (!store.getters.user.user.pp_accepted) {
        next('/privacy-policy').catch(() => { });
      };
    }
    /**
     * hardcoded homepages per client
     */
    if(to.name === 'home'){
      if (store.getters.skin === 20) {
        next('/digital-gym').catch(() => { })
      }
      switch(parseInt(store.getters.user.user_client_id)) {
        case 3519:
          next('/personal/my-company').catch(() => { })
          break;
        case 5191:
          /**
           * Workhuman
           */
          next('/clinics/digital').catch(() => { })
          break;
        default:
          next()
      }
    }
  }
  next();
}
const routes = [
  {
    path: "/login",
    name: "NotLoggedIn",
    component: NotLoggedIn,
    beforeEnter: (to, from, next) => {
      if (store.getters.subdomain === 'layaeap') {
        store.dispatch('accessCodeLogin', { router: router, accessCode: 'LayaEAP' })
      }
      next();
    }
  },
  {
    path: "/",
    name: "redirect",
    component: Redirect
  },
  {
    path: "/bupa/",
    name: "bupa-sso",
    component: BupaSso
  },
  {
    path: "*",
    name: "not-found",
    component: NotFound
  },
  {
    path: "/privacy-policy",
    name: "privacy",
    component: PrivacyPolicy
  },
  {
    path: "/terms-and-conditions",
    name: "TCs",
    component: TCs
  },
  {
    path: "/gp",
    name: "gp",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/gp/select/:appt_type",
    name: "gpSelect",
    component: LoggedIn,
    beforeEnter: beforeEnterHandler,
  },
  {
    path: "/matchtech/",
    name: "matchTech",
    component: LoggedIn,
  },
  {
    path: "/video-room/:token",
    name: "video",
    component: Video,
  },
  {
    path: "/cancel/:id",
    name: "cancelBooking",
    component: LoggedIn,
  }
];

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

if (store.getters.hardcoded && store.getters.hardcoded.permittedRoutes) {
  router.beforeEach((to, from, next) => {
    if (
      !store.getters.hardcoded.permittedRoutes.includes(to.name)
    ) {
      try {
        next(store.getters.homeRoute);
      } catch (e) {
        console.log(e)
        next('/login')
      }
    }
    next();
  });
}
export default router;
